import { render, staticRenderFns } from "./Backgrounds.vue?vue&type=template&id=68335de4&"
import script from "./Backgrounds.vue?vue&type=script&lang=js&"
export * from "./Backgrounds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports